<template>
  <div class="elite-tabs-wrapper-content">
    <h3 class="mb-4">{{ purchasesPayment.name }}</h3>
    <div class="col-12">
      <dl class="row">
        <dt class="col-sm-4">{{ $t("COMMON.DATE") }}</dt>
        <dd class="col-sm-8">
          {{ $formatDate(purchasesPayment.date) }}
        </dd>
      </dl>
      <dl
        class="row"
        v-if="$currentUserCan($permissions.PERM_VIEW_ANY_INVOICES)"
      >
        <dt class="col-sm-4">{{ $t("COMMON.INVOICE") }}</dt>
        <dd class="col-sm-8">
          <object-link :object="purchasesPayment.invoice" />
        </dd>
      </dl>

      <dl class="row">
        <dt class="col-sm-4">{{ $t("COMMON.LOCATIONS") }}</dt>
        <dd class="col-sm-8">
          <locations :locations="purchasesPayment.allowedLocations" />
        </dd>
      </dl>

      <dl
        class="row"
        v-if="$currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS)"
      >
        <dt class="col-sm-4">{{ $t("COMMON.ORGANIZATION") }}</dt>
        <dd class="col-sm-8">
          <organization :organization="purchasesPayment.organization" />
        </dd>
      </dl>

      <dl class="row">
        <dt class="col-sm-4">{{ $t("COMMON.STATUS") }}</dt>
        <dd class="col-sm-8">
          <purchasesPayment-status-badge :purchasesPayment="purchasesPayment" />
        </dd>
      </dl>

      <dl class="row">
        <dt class="col-sm-4">{{ $t("COMMON.AMOUNT") }}</dt>
        <dd class="col-sm-8">
          {{ $formatCurrency(purchasesPayment.amount) }}
        </dd>
      </dl>
      <dl class="row">
        <dt class="col-sm-4">{{ $t("PURCHASES_PAYMENTS.SOURCE") }}</dt>
        <dd class="col-sm-8">
          {{
            $t(
              `PURCHASES_PAYMENTS.PURCHASES_PAYMENT_SOURCE_${purchasesPayment.source}`
            )
          }}
        </dd>
      </dl>

      <dl class="row" v-if="purchasesPayment.excerpt">
        <dt class="col-sm-4">
          {{ $t("COMMON.EXCERPT") }}
        </dt>
        <dd class="col-sm-8">
          <div v-html="purchasesPayment.excerpt"></div>
        </dd>
      </dl>

      <dl class="row" v-if="purchasesPayment.transaction_id">
        <dt class="col-sm-4">
          {{ $t("PURCHASES_PAYMENTS.TRANSACTION_ID") }}
        </dt>
        <dd class="col-sm-8">
          {{ purchasesPayment.transaction_id }}
        </dd>
      </dl>

      <dl class="row" v-if="purchasesPayment.transaction_data">
        <dt class="col-sm-4">
          {{ $t("PURCHASES_PAYMENTS.TRANSACTION_DATA") }}
        </dt>
        <dd class="col-sm-8">
          {{ purchasesPayment.transaction_data }}
        </dd>
      </dl>

      <dl class="row">
        <dt class="col-sm-4">{{ $t("COMMON.CREATED_AT") }}</dt>
        <dd class="col-sm-8" v-if="purchasesPayment.created_at">
          {{ $formatDate(purchasesPayment.created_at) }}
        </dd>
      </dl>
      <dl class="row">
        <dt class="col-sm-4">{{ $t("COMMON.UPDATED_AT") }}</dt>
        <dd class="col-sm-8" v-if="purchasesPayment.updated_at">
          {{ $formatDate(purchasesPayment.updated_at) }}
        </dd>
      </dl>
    </div>
  </div>
</template>
<script>
import PurchasesPaymentStatusBadge from "./PurchasesPaymentStatusBadge.vue";
export default {
  name: "purchasesPayment-view-global",

  components: { PurchasesPaymentStatusBadge },

  props: ["purchasesPayment"],

  data() {
    return {};
  },

  computed: {},

  created() {},

  methods: {},

  mounted() {},

  watch: {
    purchasesPayment(purchasesPayment) {},
  },
};
</script>
